import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRedirectArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRedirectArrow"><Path d="M7.875 3C10.5674 3 12.75 5.18261 12.75 7.875V11.25H18.4395L15.7197 8.53027L16.7803 7.46973L21.3105 12L16.7803 16.5303L15.7197 15.4697L18.4395 12.75H12.75V21H11.25V12.75H7.875C5.18261 12.75 3 10.5674 3 7.875C3 5.18261 5.18261 3 7.875 3ZM7.875 4.5C6.01104 4.5 4.5 6.01104 4.5 7.875C4.5 9.73896 6.01104 11.25 7.875 11.25H11.25V7.875C11.25 6.01104 9.73896 4.5 7.875 4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRedirectArrow;
